module.exports = __webpack_public_path__ + "static/media/Clefina.0f349eab.png";